var GTM_STORAGE_KEY = 'GoogleTagManagerV2';
export var getGtmIpInfo = function () {
    try {
        var raw = window.localStorage.getItem(GTM_STORAGE_KEY);
        if (!raw)
            return '';
        var nodes = [JSON.parse(raw)];
        while (nodes.length > 0) {
            var value = nodes.pop();
            if (Array.isArray(value)) {
                for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                    var item = value_1[_i];
                    nodes.push(item);
                }
                continue;
            }
            if (typeof value !== 'object' || value === null)
                continue;
            for (var _a = 0, _b = Object.entries(value); _a < _b.length; _a++) {
                var _c = _b[_a], entryKey = _c[0], entryValue = _c[1];
                if (entryKey.replace(/[\s_-]/g, '').toLowerCase() === 'ipinfo' &&
                    (typeof entryValue === 'string' || typeof entryValue === 'number')) {
                    return String(entryValue);
                }
                nodes.push(entryValue);
            }
        }
    }
    catch (_d) {
        return '';
    }
    return '';
};
